import { render } from "./ProprietaireCreateCompte.vue?vue&type=template&id=5bcddec2&scoped=true"
import script from "./ProprietaireCreateCompte.vue?vue&type=script&lang=js"
export * from "./ProprietaireCreateCompte.vue?vue&type=script&lang=js"

import "./ProprietaireCreateCompte.vue?vue&type=style&index=0&id=5bcddec2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bcddec2"]])

export default __exports__